import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PathCard } from '@/shared/ui/path-card'

export const Route = createFileRoute('/_auth/administration/reference-books/')({
  staticData: {
    meta: {
      title: 'Справочники',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()

  return (
    <PageWrapper title={t('Справочники')}>
      <PathCard path="/administration/reference-books/schools" title={t('Школы')} />
      <PathCard path="/administration/reference-books/canteens/list" title={t('Столовые')} />
      <PathCard path="/administration/reference-books/cameras" title={t('Камеры Target AI')} />
      <PathCard path="/administration/reference-books/company" title={t('Организации')} />
    </PageWrapper>
  )
}
